export const JOB_DELAY_EVENT_PREFIX = "RealQueue/JobDelay/";
